import React from 'react';
import Form from '@lib/components/ReactHookForm/FormContainer';
import { useTranslation } from 'react-i18next';
import { GraphQLFormattedError } from 'graphql';
import { Values } from '@lib/interfaces/form';
import useQueries from 'routes/Dashboard/TasksTimeline/utils/useQueries';
import { GENERATE_REPORT_FORM } from '@lib/enums/localStorageKeys';
import useDefaultValues from './utils/getDefaultValues';
import getFormFields from './utils/getFormFields';
import GenerateReportFormActions from './GenerateReportFormActions';

interface FormProps {
  graphQLErrors?: readonly GraphQLFormattedError[];
  loading: boolean;
  onCancel: () => void;
  onSubmit: (values: Values) => void;
  filterParams: Values;
  basePeriodStartParam: string;
  basePeriodEndParam: string;
}

function GenerateReportForm(props: FormProps) {
  const {
    graphQLErrors,
    loading,
    onCancel,
    onSubmit,
    filterParams,
    basePeriodStartParam,
    basePeriodEndParam,
  } = props;
  const { t } = useTranslation();
  const { getUsersLoadOptions } = useQueries();
  const defaultValues = useDefaultValues();
  const fields = getFormFields({
    getUsersLoadOptions,
    t,
    filterParams,
    basePeriodStartParam,
    basePeriodEndParam,
  });
  return (
    <div>
      <Form
        formId={GENERATE_REPORT_FORM}
        defaultValues={defaultValues}
        onSubmit={onSubmit}
        fields={fields}
        actionsComponent={GenerateReportFormActions}
        actionsComponentProps={{
          loading,
          onCancel,
        }}
        graphQLErrors={graphQLErrors}
        loading={loading}
        persistForm
      />
    </div>
  );
}

export default GenerateReportForm;
